import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { getCurrentUser } from 'aws-amplify/auth';
import {UploadService} from '../../service';
import {ContainerEvents} from './types';
import {
    AnalysisDetails,
    Analyte,
    FileObject,
    FileObjectStatus,
    Uploads
} from '../../model/analysis-details.model';
import {AuthService} from '../../service';
import {User} from '../../model/types';
import {SharedService} from '../../layouts/shared-service';
import { Subject } from 'rxjs';
import { DialogComponent } from '../dashboard/dialog/dialog.component';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import { delay } from 'rxjs/operators';
import { AuthNewService } from '../../service/auth-new.service';


@Component({
    selector: 'app-doc-upload',
    templateUrl: './doc-upload.component.html',
    styleUrls: ['./doc-upload.component.scss'],
    standalone: false
})
export class DocUploadComponent implements OnInit {
    disabledValue;
    colorLabel = 'DarkBlue';
    uploadDisabled = true;
    pageTitle = 'New Analysis';
    files: FileObject[] = [];
    signedInUser: User;
    @Input()  analysisDetails: AnalysisDetails;
    analyte: Analyte;
    modelChanges: Subject<string> = new Subject<string>();
    finish = false;
    step = 0;
    disableAdd = false;
    fileSizeError = false;
    fileNameError = false;
    totalFileSize = 0;
    maxSize: number = 100 * 1024 * 1024; // 100MB in bytes
    fileNames: string[] = [];

    // upload_types_RSG = ['Template', 'SampleFiles', 'IntraAssayPrecision', 'Summary'];
    upload_types_RSG = ['SampleFiles'];
    upload_types_AP = ['Report'];
    upload_types_SAM = ['Sample Analysis Report', 'Method Validation Report'];
    subtype: AnalysisDetails;

    constructor(private _sharedService: SharedService,
                private authService: AuthService,
                private newAuthService: AuthNewService,
                private router: Router,
                private uploadService: UploadService,
                public dialog: MatDialog,
                private ref: ChangeDetectorRef) {
        // this._sharedService.emitChange(this.pageTitle);
        
        getCurrentUser().then(data => {
          this.signedInUser = new User(true, data.username, data.userId);
          this.uploadService.setSignedInUser(this.signedInUser);
        }).catch(e => {
          this.router.navigate(['/extra-layout/signin']);
          return;
        })
    }

    ngOnInit() {
        this.uploadService.fileUploadEvent$.subscribe(
            fileObject => this.handleFileUploadEvent(fileObject)
        );
        this.uploadService.disabledValue.subscribe(res => {
            this.disabledValue = res;
        })

        this.setRegion();
        // console.log('Passes Object',  this.analysisDetails);
        // House Keeping - Initialize necessary objects
        this.analysisDetails.analytes = [];
        this.analyte =  new Analyte(this.analysisDetails.analyteName)

        setTimeout(() => {
            this.analysisTypeFilter(this.analyte);
        }, 2000)

        this.subtype = this.analysisDetails;
    }

    analysisTypeFilter(analysis) {
        this.analyte.uploadObjs = [];
        let uploadType = 'Report'
        const obj: Uploads = {
            uploadType: uploadType,
            index: 0,
            path: this.getUploadPath('Report'),
            files: []
        };
        this.analyte.uploadObjs.push(obj);
        // console.log(this.analyte.uploadObjs);
    }

    private handleFileUploadEvent(fileObject: FileObject) {
        if (fileObject.status === FileObjectStatus.Deleted) {
            for (const upload of this.analyte.uploadObjs) {
                for (let i = 0; i < upload.files.length; i++) {
                    if (upload.files[i] === fileObject) {
                        upload.files.splice(i, 1);
                    }
                }
            }

        }
    }

    fileChangeEvent(fileInput: any, uploadType: string) {
        this.disableAdd = false;
        const selectedFiles = fileInput.target.files;
        let flag = true;

        for (const file of selectedFiles) {
            const name = file.name;
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const allowedExtensions = ['xlsx', 'xls'];
            this.totalFileSize += file.size;
            const isValid = allowedExtensions.includes(fileExtension);
            if (!isValid) {
                flag = false;
            }
            if (this.totalFileSize > this.maxSize) {
                this.fileSizeError = true;
                this.uploadDisabled = false;
            }
            if (this.fileNames.includes(name)) {
                this.fileNameError = true;
                this.uploadDisabled = false;
            }
            this.fileNames.push(name);
            for (const index in this.analyte.uploadObjs) {
                const i = Number(index);
                if (this.analyte.uploadObjs[i].uploadType === uploadType) {
                    const fileObject = new FileObject(file, uploadType, isValid);
                    this.analyte.uploadObjs[i].files.push(fileObject);
                    this.analyte.tempPath = this.analyte.uploadObjs[i].path;
                }
            }
        }
        if (flag && !this.fileSizeError && !this.fileNameError) {
            this.uploadDisabled = false;
            this.fileSizeError = false;
            this.fileNameError = false;
        } else {
            this.uploadDisabled = true;
        }
        fileInput.target.value = null;

    }

    async uploadAll(uploadType: string) {
        this.uploadService.setAnalysisData(this.analyte);
        this.uploadService.publishUploadContainerEvent(ContainerEvents.Upload);
        this.updateAnalysisDetails(uploadType);
        this.uploadDisabled = false;
        this.disableAdd = true;
        if (this.analyte.uploadObjs[0]?.files) {
            const total_files = this.analyte.uploadObjs[0].files.length;
            let uploaded_files = 0;
            for (const fileObject of this.analyte.uploadObjs[0].files) {
                fileObject.status = FileObjectStatus.NotStarted;
                try {
                    fileObject.status = FileObjectStatus.Uploading;
                    const file_path = this.analyte.uploadObjs[0].path;
                    this.uploadService.uploadFile(fileObject, file_path).subscribe({
                        next: (response) => {
                            fileObject.status = FileObjectStatus.Uploaded;
                            uploaded_files++;

                            if (uploaded_files === total_files) {
                                this.uploadService.disabledValue.next(false);
                            }
                        },
                        error: (err) => {
                            fileObject.status = FileObjectStatus.Failed;
//                             console.error(err);
                        }
                    });
                } catch (error) {
                    fileObject.status = FileObjectStatus.Failed;
//                     console.error(error);
                }
            }
        }
    }

    getUploadPath(uploadType: string) {
        const relativePath = [this.signedInUser?.username,
            this.analysisDetails?.analysisId].join('/');

        if (uploadType === 'Template') {
            return [relativePath, uploadType].join('/');
        } else {
            return  [relativePath, this.analyte.analyteName, uploadType].join('/');
        }
    }

    updateAnalysisDetails(uploadType: string) {

        let analyteFound = false;
        let typefound = false;
        if (this.analysisDetails.analytes.length > 0) {


            let uploadObj: Uploads;
            // console.log('this.analyte.uploadObjs ', this.analyte.uploadObjs);
            for (const obj of this.analyte.uploadObjs) {
                if (obj.uploadType === uploadType) {
                    uploadObj = obj;

                }
            }


            for (let i = 0; i < this.analysisDetails.analytes.length; i++) {
                if ( this.analysisDetails.analytes[i].analyteName === this.analyte.analyteName) {
                    analyteFound = true;
                    for (let j = 0; j < this.analysisDetails.analytes[i].uploadObjs.length; j++) {
                        if (this.analysisDetails.analytes[i].uploadObjs[j].uploadType === uploadType) {
                            typefound = true;
                            // console.log('update object' , uploadObj.files);
                            this.analysisDetails.analytes[i].uploadObjs[j].files = []
                            this.analysisDetails.analytes[i].uploadObjs[j].files
                                .push(...JSON.parse(JSON.stringify(uploadObj.files)));
                                // console.log('xyz', this.analysisDetails.analytes[i].uploadObjs[j].files.length)

                            break;
                        }
                    }
                    if (!typefound) {
                        // console.log('Should be unreachable code, FLAG ERROR ', uploadType);
                        for (let k = 0; k < this.analyte.uploadObjs.length; k++) {
                            if (this.analyte.uploadObjs[k].uploadType === uploadType) {
                                this.analysisDetails.analytes[i].uploadObjs.push(JSON.parse(JSON.stringify(this.analyte.uploadObjs[k])));
                            }
                        }
                    }
                }
            }
            if (!analyteFound) {
                this.analysisDetails.analytes.push(JSON.parse(JSON.stringify(this.analyte)));
            }
        } else {
            this.analysisDetails.analytes.push(JSON.parse(JSON.stringify(this.analyte)));
        }
    }



    clearAll() {
        // console.log('clear All function');
        this.uploadService.publishUploadContainerEvent(ContainerEvents.Delete);
    }


    setRegion() {
        const queryParams = this.router.routerState.snapshot.root.queryParams;
        if (queryParams && queryParams.region) {
            this.uploadService.setRegion(queryParams.region);
        }
    }

    onChangeAnalysisType(str) {
        this.modelChanges.next(str);
    }


    setStep(index: number) {
        this.step = index;
        this.uploadService.publishUploadContainerEvent(ContainerEvents.Delete);
    }

    nextStep() {
        this.uploadService.publishUploadContainerEvent(ContainerEvents.Delete);
        this.step++;
    }

    prevStep() {
        this.step--;
        this.clearAll();
    }

    submit() {
        this.uploadService.submitForAnalysis(this.analysisDetails).subscribe(
            (result) => {
                // console.log(' result', result);
                // console.log(this.analysisDetails.analysisType);
                this.router.navigate(['/default-layout/molecule-analysis' , this.analysisDetails.analysisId,
                  this.signedInUser.username]);
            },
            (error) => {
                // console.log(error);
            }
        );

    }

}
